import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useEventApi() {
  const callApi = useApiCall();

  const getCountries = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.COUNTRIES, data, onSuccess, onError, false);
  };

  const getStates = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.STATES, data, onSuccess, onError, false);
  };

  const getCities = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.CITIES, data, onSuccess, onError, false);
  };

  const getGameSettings = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.GAME_DETAILS, data, onSuccess, onError);
  };

  const getIndustries = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.INDUSTRIES, data, onSuccess, onError, false);
  };

  const getCountriesNew = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.COUNTRIES_NEW, data, onSuccess, onError, false);
  };

  const getCitiesNew = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.CITIES_NEW, data, onSuccess, onError, false);
  };

  const getDesignations = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.DESIGNATIONS, data, onSuccess, onError, false);
  };

  return {
    callGetCountries: getCountries,
    callGetStates: getStates,
    callGetCities: getCities,
    callGetGameDetails: getGameSettings,
    callGetIndustries: getIndustries,
    callGetCountriesNew: getCountriesNew,
    callGetCitiesNew: getCitiesNew,
    callGetDesignations: getDesignations,
  };
}
